<template>
  <div class="content webHome" v-cloak>
    <div class="title">
      <div>在线投稿系统</div>
      <div>
        <span>{{ userInfo.name }}</span>
        <span
          style="color: #278dfe; margin-left: 10px; cursor: pointer"
          @click="logout"
          >【退出】</span
        >
      </div>
    </div>
    <div class="btns">
      <button class="btns1Button" @click="contributinoEvent">
        <img src="../assets/image/submit.png" alt="" />
        投稿（提交新稿件）
      </button>
	  <!--
      <button class="btns2Button" @click="uploadVoucher">
        <img src="../assets/image/upload.png" alt="" />
        上传缴费凭证
      </button>
	  -->
      <button class="btns3Button" @click="stationList">
        <img src="../assets/image/mess.png" alt="" />
        站内信息
      </button>
    </div>
    <!-- 表格 -->
    <div class="tablesDiv" v-cloak>
      <ul>
        <li
          v-for="(item, index) in liList"
          :key="index"
          :class="{ 'is-active': index == activeIdx }"
          @click="tableSwitch(index)"
        >
          {{ item.title }}
          <p class="newStatus" v-if="newStatusSwitch == index"></p>
        </li>
      </ul>
      <!-- 审核中 -->
      <div v-show="activeIdx == 0">
        <el-table
          :data="tableData"
          border
          style="width: 1160px; margin: 37px auto 34px"
          :header-cell-style="{ background: '#f5f6f8', color: '#333333' }"
          :row-style="{ height: '47px' }"
        >
          <el-table-column
            prop="title"
            width="190"
            header-align="center"
            align="center"
            label="稿件中文标题"
          >
          </el-table-column>
          <el-table-column
            prop="author"
            header-align="center"
            align="center"
            label="作者"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            header-align="center"
            align="center"
            label="上传时间"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            header-align="center"
            align="center"
            label="状态"
            width="195"
          >
            <template slot-scope="scope">
              {{ scope.row.status === 1 ? "审核中" : "待修改" }}
              <p id="spot_b" v-if="scope.row.status === 1"></p>
              <p id="spot_o" v-else></p>
            </template>
          </el-table-column>
          <el-table-column
            prop="fileName"
            header-align="center"
            align="center"
            label="附件名称"
            width="195"
          >
            <template slot-scope="scope">
              <p class="textP" @click="downloadUnderReview(scope.row)">
                {{ scope.row.fileName }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            width="190"
            header-align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
			  <el-button
			    type="text"
			    v-if="scope.row.status === 1"
			    @click="reMentionShenHe(scope.row)"
			    >重新上传</el-button
			  >	
				
              <el-button
                type="text"
                v-if="scope.row.status === 2"
                @click="reMention(scope.row)"
                >重新提交</el-button
              >
              <span
                style="color: #bcbcbc; margin: 0 5px"
                >|</span
              >
              <el-button type="text" @click="downloadUnderReview(scope.row)"
                >下载</el-button
              >
              <span
                style="color: #bcbcbc; margin: 0 5px"
                v-if="scope.row.status === 2"
                >|</span
              >
              <el-button
                type="text"
                v-if="scope.row.status === 2"
                @click="updadeReason(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 录用 -->
      <div v-show="activeIdx == 1">
        <el-table
          :data="tableData"
          border
          style="width: 1160px; margin: 37px auto 34px"
          :header-cell-style="{ background: '#f5f6f8', color: '#333333' }"
          :row-style="{ height: '47px' }"
        >
          <el-table-column
            prop="title"
            width="320"
            header-align="center"
            align="center"
            label="稿件中文标题"
          >
          </el-table-column>
          <el-table-column
            prop="author"
            header-align="center"
            align="center"
            label="作者"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            header-align="center"
            align="center"
            label="上传时间"
            width="270"
          >
          </el-table-column>

          <!-- <el-table-column
            width="260"
            prop="fileName"
            header-align="center"
            align="center"
            label="附件名称"
          >
            <template slot-scope="scope">
              <p class="textP" @click="download(scope.row)">
                {{ scope.row.fileName }}
              </p>
            </template>
          </el-table-column> -->
		  
          <el-table-column
            width="250"
            header-align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
             <!-- <el-button type="text" @click="download(scope.row)"
                >下载</el-button
              >
              <span style="color: #bcbcbc; margin: 0 5px">|</span> -->
              <el-button type="text" @click="seeNotic(scope.row)"
                >查看</el-button
              >
			   <span style="color: #bcbcbc; margin: 0 5px">|</span>
			   <el-button type="text" @click="uploadVoucher(scope.row)"
			     >上传缴费凭证</el-button
			   >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 退稿 -->
      <div v-show="activeIdx == 2">
        <el-table
          :data="tableData"
          border
          style="width: 1160px; margin: 37px auto 34px"
          :header-cell-style="{ background: '#f5f6f8', color: '#333333' }"
          :row-style="{ height: '47px' }"
        >
          <el-table-column
            prop="title"
            width="300"
            header-align="center"
            align="center"
            label="稿件中文标题"
          >
          </el-table-column>
          <el-table-column
            prop="author"
            header-align="center"
            align="center"
            label="作者"
            width="250"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            header-align="center"
            align="center"
            label="上传时间"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            header-align="center"
            align="center"
            label="退稿时间"
            width="209"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="fileName"
            header-align="center"
            align="center"
            label="退回稿件"
          >
            <template slot-scope="scope">
              <p class="textP" @click="download(scope.row)">
                {{ scope.row.fileName }}
              </p>
            </template>
          </el-table-column> -->
          <el-table-column
            width="200"
            header-align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
             <!-- <el-button type="text" @click="download(scope.row)"
                >下载</el-button
              >
              <span style="color: #bcbcbc; margin: 0 5px">|</span> -->
              <el-button type="text" @click="reason(scope.row)"
                >查看退稿原因</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 缴费状态 -->
      <div v-show="activeIdx == 3">
        <el-table
          :data="tableData"
          border
          style="width: 1160px; margin: 37px auto 34px"
          :header-cell-style="{ background: '#f5f6f8', color: '#333333' }"
          :row-style="{ height: '47px' }"
        >
          <el-table-column
            prop="title"
            width="260"
            header-align="center"
            align="center"
            label="稿件中文标题"
          >
          </el-table-column>
          <el-table-column
            width="132"
            prop="author"
            header-align="center"
            align="center"
            label="作者"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            header-align="center"
            align="center"
            label="上传时间"
            width="195"
          >
          </el-table-column>

          <el-table-column
            prop="fileName"
            header-align="center"
            align="center"
            width="192"
            label="文件名称"
          >
            <template slot-scope="scope">
              <p class="textP" @click="download(scope.row)">
                {{ scope.row.fileName }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            header-align="center"
            align="center"
            label="状态"
            width="195"
          >
            <template slot-scope="scope">
              {{ scope.row.status }}
              <p id="spot_b" v-if="scope.row.status === '待审核'"></p>
              <p id="spot_o" v-else></p>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            width="185"
            header-align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="download(scope.row)"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 小样确认 -->
      <div v-show="activeIdx == 4" style="padding: 0 9px">
       <!-- <el-button class="uploadSample" @click="uploadSample = true"
          >上传小样</el-button
        > -->
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="我接收的" name="receive">
            <el-table
              :data="receiveData"
              border
              style="margin: 17px auto 34px"
              :header-cell-style="{ background: '#f5f6f8', color: '#333333' }"
              :row-style="{ height: '47px' }"
            >
              <el-table-column
                prop="title"
                width="285"
                header-align="center"
                align="center"
                label="稿件中文标题"
              >
              </el-table-column>
              <el-table-column
                width="180"
                prop="author"
                header-align="center"
                align="center"
                label="作者"
              >
              </el-table-column>
              <el-table-column
                prop="updateTime"
                header-align="center"
                align="center"
                label="接收时间"
                width="160"
              >
              </el-table-column>
			  
			  <el-table-column
			    prop="fileName"
			    header-align="center"
			    align="center"
			    label="文件名称"
			    width="190"
			  >
			  <template slot-scope="scope">
			    <p class="textP" @click="download(scope.row)">
			      {{ scope.row.fileName }}
			    </p>
			  </template>
			  </el-table-column>

              <el-table-column
                prop="remark"
                header-align="center"
                align="center"
                label="说明"
                width="245"
              >
              </el-table-column>
              <el-table-column
                width="120"
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="download(scope.row)"
                    >下载</el-button
                  >
				  <span style="color: #bcbcbc; margin: 0 5px">|</span>
				  <el-button type="text" @click="uploadSampleFun(scope.row)"
				    >上传小样</el-button
				  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="我发送的" name="sendOut">
            <el-table
              :data="tableData"
              border
              style="margin: 17px auto 34px"
              :header-cell-style="{ background: '#f5f6f8', color: '#333333' }"
              :row-style="{ height: '47px' }"
            >
              <el-table-column
                prop="title"
                width="290"
                header-align="center"
                align="center"
                label="稿件中文标题"
              >
              </el-table-column>
              <el-table-column
                width="180"
                prop="author"
                header-align="center"
                align="center"
                label="作者"
              >
              </el-table-column>
              <el-table-column
                prop="createTime"
                header-align="center"
                align="center"
                label="上传时间"
                width="160"
              >
              </el-table-column>

              <el-table-column
                prop="fileName"
                header-align="center"
                align="center"
                label="文件名称"
                width="190"
              >
			  <template slot-scope="scope">
			    <p class="textP" @click="download(scope.row)">
			      {{ scope.row.fileName }}
			    </p>
			  </template>
              </el-table-column>
			  
			  <el-table-column
			    prop="remark"
			    header-align="center"
			    align="center"
			    label="说明"
			    width="260"
			  >
			  </el-table-column>
			   
              <el-table-column
                width="100"
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="download(scope.row)"
                    >下载</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 已发表 -->
      <div v-show="activeIdx == 5">
        <el-table
          :data="tableData"
          border
          style="margin: 37px auto 34px; width: 1160px"
          :header-cell-style="{ background: '#f5f6f8', color: '#333333' }"
          :row-style="{ height: '47px' }"
        >
          <el-table-column
            prop="title"
            width="230"
            header-align="center"
            align="center"
            label="稿件中文标题"
          >
          </el-table-column>
          <el-table-column
            width="150"
            prop="author"
            header-align="center"
            align="center"
            label="作者"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            header-align="center"
            align="center"
            label="上传时间"
            width="195"
          >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            header-align="center"
            align="center"
            label="发表时间"
            width="195"
          >
          </el-table-column>
          <el-table-column
            prop="fileName"
            header-align="center"
            align="center"
            label="文件名称"
            width="208"
          >
            <template slot-scope="scope">
              <p class="textP" @click="download(scope.row)">
                {{ scope.row.fileName }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="stageNum"
            width="180"
            header-align="center"
            align="center"
            label="发表期数"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <p style="font-size: 14px; color: #333333" v-if="activeIdx == 0">
      注意事项：
    </p>
    <p
      style="color: #e20011; font-size: 13px"
      v-if="activeIdx == 0"
      @click="baoming"
    >
      文章修改稿请在一周内回复！
    </p>

    <el-dialog
      title="退稿操作"
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      center
    >
      <div style="border: 1px solid #e5e5e5">
        <span class="posiReason">退稿原因：</span>
        <div class="rejectionContent">
          {{ rejectionRemark }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="centerDialogVisible = false"
          >取消</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="修改操作"
      :visible.sync="updateReasonDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      center
    >
      <div style="border: 1px solid #e5e5e5">
        <span class="posiReason">修改原因：</span>
        <div class="rejectionContent">
          {{ updateRemark }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="uploadSample" @click="updateReasonDialog = false"
          >取消</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="重新上传"
      :visible.sync="reMentionDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      center
      @close="closeMention"
    >
      <!-- <div style="border: 1px solid #e5e5e5">
        <span class="posiReason">修改原因：</span>
        <div class="rejectionContent">
          {{ updateRemark }}
        </div>
      </div> -->
      <p class="mentionP">请选择要重新上传的文件</p>
      <div class="file">
        <i
          style="font-weight: bold; color: #797984; margin-right: 10px"
          class="el-icon-upload2"
        ></i>
        上传文件
        <label class="fileInput">
          <input
            type="file"
            class="fileInput"
            name=""
            id=""
            style="display: none"
            @change="reMentionFileAndUpload"
          />
		   <!-- accept=".jpg, .png, .jpeg, .bmp .pdf .docx .dox" -->
        </label>
      </div>
      <ul class="fileUl">
        <li v-for="(item, index) in mentionFile" :key="index">
          {{ item.fileName }}
          <!-- <span>删除</span> -->
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button class="uploadSample" @click="submitReMention"
          >提交</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      id="rejection"
      title="上传发送小样"
      :visible.sync="uploadSample"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      @close="close"
      center
    >
      <div class="dialogContent">
        <p>小样确认说明</p>
        <div style="border: 1px solid #e5e5e5; margin: 15px 0">
          <el-input
		    maxlength="255"
		    show-word-limit
            class="posiInput"
            type="textarea"
			v-model="remarkSample"
            :autosize="{ minRows: 2, maxRows: 4 }"
			placeholder="请输入小样确认说明"
          ></el-input>
        </div>
      </div>
      <div class="file">
        <i
          style="font-weight: bold; color: #797984; margin-right: 10px"
          class="el-icon-upload2"
        ></i>
        上传文件
        <label class="fileInput">
          <input
            type="file"
            class="fileInput"
            name=""
            id=""
            style="display: none"
            @change="getFileAndUpload"
          />
		<!--   accept=".jpg, .png, .jpeg, .bmp .pdf .docx .dox" -->
        </label>
      </div>
      <ul class="fileUl">
        <li v-for="(item, index) in fileList" :key="index">
          {{ item.fileName }}
          <!-- <span>删除</span> -->
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button class="sampleFile" @click="submitSample">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { setInterval } from "timers";
import mathType from "../utils/func";
let vm = null;
export default {
  data() {
    return {
      newStatusSwitch: null,
      sessionNew: null,
      remarkSample: "",
      centerDialogVisible: false,
      updateReasonDialog: false,
      uploadSample: false,
	  uploadSampleId: null,
      reMentionDialog: false,
      downloadUrl: "",
      tableData: [],
      receiveData: [], // 我接收
      liList: [
        {
          title: "审核中",
        },
        {
          title: "录用",
        },
        {
          title: "退稿",
        },
        {
          title: "缴费状态",
        },
        {
          title: "小样确认",
        },
        {
          title: "已发表",
        },
      ],
      activeIdx: null,
      activeName: "receive",
      rejectionRemark: "",
      updateRemark: "",
      userInfo: null,
      pageIndex: 1,
      pageSize: 10,
      downloadFileUrl: window.SITE_CONFIG["baseUrl"],
      fileList: [],
      ruleForm: {
        name: "",
        path: "",
        size: 0,
      },
      mentionFileObj: {
        name: "",
        path: "",
        size: 0,
      },
      mentionStatus: false,
      mentionManuScriptId: null,
      mentionManuScriptAuthor: "",
      mentionFile: [],
    };
  },
  created() {
    // sessionStorage.setItem("newStatusSwitch", null);
    let sessionUser = JSON.parse(sessionStorage.getItem("user"));
    if (sessionUser) {
      this.userInfo = sessionUser;
    } else {
      this.$message.error("请登录后查看");
      this.$cookie.delete("magazineToken");
      this.$router.push({
        path: "/magaZineLogin",
      });
    }
    this.getAllStatusData();
  },

  mounted() {
    this.sessionNew = sessionStorage.getItem("newStatusSwitch"); // 为了初始化时判断哪个状态有更新，并加上小红点

    let sessionTabSitch = sessionStorage.getItem("webTableSwitch");
    this.activeIdx = sessionTabSitch ? sessionTabSitch : 0;
    this.$store.commit("SET_HEADERSWITCH", 0);
    this.tableSwitch(sessionTabSitch ? sessionTabSitch * 1 : 0);
  },
  methods: {
    // 获取全部状态数据，改变newStatusSwitch
    getAllStatusData() {
      let statusStorage = null;
      this.$http({
        url: "/api/manuscriptList",
        method: "get",
        params: this.$http.adornParams({
          status: "",
          usrid: this.userInfo.usrid,
        }),
      })
        .then((response) => {
          let { code, msg, data } = response.data;
          if (code === "1") {
            data.recordList.map((ele) => {
              statusStorage =
                ele.status == 1 || ele.status == 2
                  ? 0
                  : ele.status == 3
                  ? 1
                  : ele.status == 4
                  ? 2
                  : ele.status == 5 || ele.status == 6
                  ? 3
                  : ele.status == 7 || ele.status == 8
                  ? 4
                  : ele.status == 10
                  ? 5
                  : sessionNew;
            });
			// 点击带红点的状态后在当前状态再次刷新页面不让红点出现
			this.newStatusSwitch = statusStorage == sessionStorage.getItem("newStatusSwitch") ? null : statusStorage;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((err) => {
          this.$message.error(msg);
        });
    },

    close() {
      this.remarkSample = "";
      this.fileList = [];
    },
    closeMention() {
      this.mentionFile = [];
    },

	uploadSampleFun(obj){
		this.uploadSampleId = obj.id;
		this.uploadSample = true;
	},
	
    // 上传小样提交
    submitSample() {
      // if (this.receiveData.length === 0) {
      //   this.$message.warning("请在接收到管理员小样后再进行小样上传");
      //   return false;
      // }
	  if (this.remarkSample.length === 0) {
		 this.$message.warning("请填写小样确认说明");
		 return false;
	  } 		
	  // if (this.fileList.length === 0) {
		 //  this.$message.warning("请选择上传文件");
		 //  return false;
	  // } 	
	  let id = this.uploadSampleId;
      this.$http({
        url: "/api/uploadSpecimen",
        method: "post",
        params: this.$http.adornParams({
          id: id,
          fileName: this.ruleForm.name,
          filePath: this.ruleForm.path,
          fileSize: this.ruleForm.size,
          remark: this.remarkSample,
        }),
      })
        .then((response) => {
          let { code, msg } = response.data;
          if (code === "1" && msg === "成功") {
            this.$message.success(msg);
            this.uploadSample = false;
            this.close();
			 this.tableSwitch(4);
          } else {
            this.$message.error(msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 文件上传
    getFileAndUpload() {
      if (this.fileList.length >= 1) {
        return false;
      } else {
        let file = event.target.files;
        var formData = new FormData();
        formData.append("uploadFile", file[0]);
        this.$http({
          url: "/api/file/upload",
          method: "post",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            let { code, msg, data } = response.data;
            if (code === "1") {
              this.fileList.push({
                fileName: data.fileName,
                filePath: data.path,
                fileSize: data.size,
              });
              this.ruleForm.path = data.path;
              this.ruleForm.name = data.fileName;
              this.ruleForm.size = data.size;
              this.$message.success("文件上传成功");
            } else {
              // this.$message.error("登录失效，请重新登录后上传");
			  this.$message.warning(msg);
            }
          })
          .catch((err) => console.log(err));
      }
    },

    // 重新上传文件提交
    reMentionFileAndUpload() {
      let file = event.target.files;
      var formData = new FormData();
      formData.append("uploadFile", file[0]);
      this.$http({
        url: "/api/file/upload",
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          let { code, msg, data } = response.data;
          if (code === "1") {
            this.mentionFile.push({
              fileName: data.fileName,
              filePath: data.path,
              fileSize: data.size,
            });
            this.mentionFileObj.path = data.path;
            this.mentionFileObj.name = data.fileName;
            this.mentionFileObj.size = data.size;
            this.mentionStatus = true;
          } else {
            // this.$message.error("登录失效，请重新登录后上传");
			this.$message.warning(msg);
          }
        })
        .catch((err) => console.log(err));
    },
    // 确认重提
    submitReMention() {
	  if (this.mentionFile.length === 0) {
			  this.$message.warning("请选择上传文件");
			  return false;
	  } 		
		console.log(this.mentionStatus+"------------this.mentionStatus");
      if (this.mentionStatus) {
        this.$http({
          url: "/api/updateManuscript",
          method: "post",
          data: this.$http.adornData({
            id: this.mentionManuScriptId,
            fileName: this.mentionFileObj.name,
            filePath: this.mentionFileObj.path,
            fileSize: this.mentionFileObj.size,
            author: this.mentionManuScriptAuthor,
          }),
        })
          .then((response) => {
            let { code, msg } = response.data;
            if (code === "1") {
              this.reMentionDialog = false;
              this.$message.success(msg);
			  this.closeMention();
              this.tableSwitch(0);
            } else {
              this.$message.error(msg);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } else {
        this.$message.warning("请选择要重新提交的文件");
      }
    },

    // 投稿
    contributinoEvent() {
      this.$router.push({
        path: "/contribution",
      });
    },
    // 上传缴费凭证
    uploadVoucher(obj) {
      // this.$router.push({
      //   path: "/uploadVoucher",
      // });
	  
	  this.$router.push({
	    path: "/uploadVoucher",
	    query: {
	      id: obj.id,
	    },
	  });
    },
    // 站内信息
    stationList() {
      this.$router.push({
        path: "/stationInfo",
      });
    },
    tableSwitch(index) {
      this.tableData = [];
      this.activeIdx = index;
      sessionStorage.setItem("webTableSwitch", index);
      switch (index) {
        case 0:
          this.getUnderReview();
          break;
        case 1:
          this.getEmployed();
          break;
        case 2:
          this.getRejection();
          break;
        case 3:
          this.getPayStatus();
          break;
        case 4:
          this.handleClick({ index: "0" });
          break;
        case 5:
          this.getPublish();
          break;
        default:
          this.getUnderReview();
      }
    },

    // 获取审核中
    getUnderReview() {
      this.tableData = [];
      if (this.newStatusSwitch === this.activeIdx) {
        this.newStatusSwitch = null;
        sessionStorage.setItem("newStatusSwitch", 0);
      }
      this.$http({
        url: "/api/manuscriptList",
        method: "get",
        params: this.$http.adornParams({
          status: "1,2",
          pageNo: this.pageIndex,
          length: this.pageSize,
          usrid: this.userInfo.usrid,
        }),
      })
        .then((response) => {
          let { code, msg, data } = response.data;
          if (code === "1") {
            data.recordList.map((ele) => {
              ele.createTime = ele.createTime
                ? this.$moment(ele.createTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
            });
            this.tableData = data.recordList;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((err) => {
          this.$message.error(msg);
        });
    },
    // 获取已录用
    getEmployed() {
      this.tableData = [];
      if (this.newStatusSwitch === this.activeIdx) {
        this.newStatusSwitch = null;
        sessionStorage.setItem("newStatusSwitch", 1);
      }
      this.$http({
        url: "/api/manuscriptList",
        method: "get",
        params: this.$http.adornParams({
          status: "3",
          pageNo: this.pageIndex,
          length: this.pageSize,
          usrid: this.userInfo.usrid,
        }),
      })
        .then((response) => {
          let { code, msg, data } = response.data;
          if (code === "1") {
            data.recordList.map((ele) => {
              ele.createTime = ele.createTime
                ? this.$moment(ele.createTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              ele.updateTime = ele.updateTime
                ? this.$moment(ele.updateTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
            });
            this.tableData = data.recordList;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((err) => console.log(err));
    },
    // 获取退稿
    getRejection() {
      this.tableData = [];
      if (this.newStatusSwitch === this.activeIdx) {
        this.newStatusSwitch = null;
        sessionStorage.setItem("newStatusSwitch", 2);
      }
      this.$http({
        url: "/api/manuscriptList",
        method: "get",
        params: this.$http.adornParams({
          status: "4",
          pageNo: this.pageIndex,
          length: this.pageSize,
          usrid: this.userInfo.usrid,
        }),
      })
        .then((response) => {
          let { code, msg, data } = response.data;
          if (code === "1") {
            data.recordList.map((ele) => {
              ele.createTime = ele.createTime
                ? this.$moment(ele.createTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              ele.updateTime = ele.updateTime
                ? this.$moment(ele.updateTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
            });
            this.tableData = data.recordList;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((err) => console.log(err));
    },
    // 获取缴费状态
    getPayStatus() {
      this.tableData = [];
      if (this.newStatusSwitch === this.activeIdx) {
        this.newStatusSwitch = null;
        sessionStorage.setItem("newStatusSwitch", 3);
      }
      this.$http({
        url: "/api/manuscriptList",
        method: "get",
        params: this.$http.adornParams({
          status: "5,6",
          pageNo: this.pageIndex,
          length: this.pageSize,
          usrid: this.userInfo.usrid,
        }),
      })
        .then((response) => {
          let { code, msg, data } = response.data;
          if (code === "1") {
            data.recordList.map((ele) => {
              ele.createTime = ele.createTime
                ? this.$moment(ele.createTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              ele.updateTime = ele.updateTime
                ? this.$moment(ele.updateTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              ele.status = ele.status === 5 ? "待审核" : "已审核";
            });
            this.tableData = data.recordList;
          } else {
            this.$$message.error(msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 已发表
    getPublish() {
      this.tableData = [];
      if (this.newStatusSwitch === this.activeIdx) {
        this.newStatusSwitch = null;
        sessionStorage.setItem("newStatusSwitch", 5);
      }
      this.$http({
        url: "/api/manuscriptList",
        method: "get",
        params: this.$http.adornParams({
          status: "10",
          pageNo: this.pageIndex,
          length: this.pageSize,
          usrid: this.userInfo.usrid,
        }),
      })
        .then((response) => {
          let { code, msg, data } = response.data;
          if (code === "1") {
            data.recordList.map((ele) => {
              console.log(ele)
              ele.createTime = ele.createTime
                ? this.$moment(ele.createTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              ele.updateTime = ele.updateTime
                ? this.$moment(ele.updateTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              ele.status = "已发表";
            });
            this.tableData = data.recordList;
          } else {
            this.$$message.error(msg);
          }
        })
        .catch((err) => console.log(err));
    },

    // 小样确认（我发送的、我接收的切换）
    handleClick(tab, event) {
      this.tableData = [];
      if (this.newStatusSwitch === this.activeIdx) {
        this.newStatusSwitch = null;
        sessionStorage.setItem("newStatusSwitch", 4);
      }
      if (tab.index == 0) {
        this.$http({
          url: "/api/manuscriptList",
          method: "get",
          params: this.$http.adornParams({
            status: "7",
            pageNo: this.pageIndex,
            length: this.pageSize,
            usrid: this.userInfo.usrid,
          }),
        })
          .then((response) => {
            let { code, msg, data } = response.data;
            if (code === "1") {
              data.recordList.map((ele) => {
                ele.createTime = ele.createTime
                  ? this.$moment(ele.createTime).format("YYYY-MM-DD HH:mm:ss")
                  : "";
                ele.updateTime = ele.updateTime
                  ? this.$moment(ele.updateTime).format("YYYY-MM-DD HH:mm:ss")
                  : "";
              });
			  let filterStatus = data.recordList.filter((res) => {
			    return res.remark = res.manuscriptItemList[0].remark;
			  });
              this.receiveData = data.recordList;
            } else {
              this.$$message.error(msg);
            }
          })
          .catch((err) => console.log(err));
      } else {
        this.$http({
          url: "/api/manuscriptList",
          method: "get",
          params: this.$http.adornParams({
            status: "8",
            pageNo: this.pageIndex,
            length: this.pageSize,
            usrid: this.userInfo.usrid,
          }),
        })
          .then((response) => {
            let { code, msg, data } = response.data;
            if (code === "1") {
              // let filterList = data.recordList[0].manuscriptItemList.filter(
              //   (ele) => {
              //     return ele.optName !== "管理员";
              //   }
              // );
              // filterList.map((res) => {
              //   res.createTime = res.createTime
              //     ? this.$moment(res.createTime).format("YYYY-MM-DD HH:mm:ss")
              //     : "";
              //   res.manuscriptName = data.recordList[0].title;
              // });
              // this.tableData.push(filterList[0]);

              data.recordList.map((ele) => {
                ele.createTime = ele.createTime
                  ? this.$moment(ele.createTime).format("YYYY-MM-DD HH:mm:ss")
                  : "";
                ele.updateTime = ele.updateTime
                  ? this.$moment(ele.updateTime).format("YYYY-MM-DD HH:mm:ss")
                  : "";
              });
			  
			  let filterStatus = data.recordList.filter((res) => {
			    return res.remark = res.manuscriptItemList[0].remark;
			  });
              this.tableData = data.recordList;
            } else {
              this.$$message.error(msg);
            }
          })
          .catch((err) => console.log(err));
      }
    },
	
    // 下载
    download(eventObj) {
      let eventFileName = eventObj.fileName;
      let eligibleObj = eventObj.manuscriptItemList.find((res) => {
        return res.fileName === eventFileName;
      });
      let eventDownFileName = eventFileName.split(".")[0];
      if (eligibleObj.filePath) {
        // let name = mathType(eventFileName);
        // window.location.href =
        //   this.downloadFileUrl +
        //   `/api/file/download?tbl=manuscirptItem&id=${eligibleObj.id}`;
        this.$http({
          url: "/api/file/download",
          method: "get",
          params: this.$http.adornParams({
            tbl: "manuscirptItem",
            id: eligibleObj.id,
            downFileName: eventDownFileName,
          }),
        })
          .then((response) => {
            if (response.data) {
              window.location.href =
                this.downloadFileUrl +
                `/api/file/download?tbl=manuscirptItem&id=${eligibleObj.id}&downFileName=${eventDownFileName}`;
            } else {
              this.$message.warning("文件不存在");
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } else {
        this.$message.warning("当前稿件未上传附件或未查找到当前附件！");
      }
    },

	// 审核中下载
	downloadUnderReview(eventObj) {
		let eventFileName = eventObj.fileName;
		//--manuscriptItemList 根据创建时间倒序， manuscript中fileName也是Item中最后一条的fileName
		let eligibleObj = eventObj.manuscriptItemList.find((res) => {
		  return res.fileName === eventFileName;
		});
		
		this.$http({
		  url: "/api/updateWaitUploadTime",
		  method: "post",
		  params: this.$http.adornParams({
		    id: eligibleObj.id,
		  }),
		})
		  .then((response) => {
		    let { code, data } = response.data;
			if (code === "1") {
				this.download(eventObj);
			}
		  })
		  .catch((err) => {
		    this.$message.error(err);
		  });
	},

    // 录用查看
    seeNotic(obj) {
      this.$router.push({
        path: "/manuscriptNotice",
        query: {
          id: obj.id,
        },
      });
    },


 // 审核中重提
    reMentionShenHe(event) {
		this.reMentionDialog = true;
		this.mentionManuScriptId = event.id;
		this.mentionManuScriptAuthor = event.author;
    },

    // 审核中重提
    reMention(event) {
		this.$http.get(`/api/manuscript/`+event.id).then((response) => {
		  let { code, msg, data } = response.data;
		  let { manuscriptItemList } = data;
		  let dataFileName = data.fileName;
		  if (code === "1") {
		   //--manuscriptItemList 根据创建时间倒序， manuscript中fileName也是Item中最后一条的fileName
		   let eligibleObj = manuscriptItemList.find((res) => {
		     return res.fileName === dataFileName;
		   });
		   if(eligibleObj.waitUpdateUploadTime === null || eligibleObj.waitUpdateUploadTime===""){
		   	  this.$message.warning("请您下载最新的附件！");
			  //刷新下页面
			  this.tableSwitch(0);
		   }else{
		   	this.reMentionDialog = true;
		   	this.mentionManuScriptId = event.id;
		   	this.mentionManuScriptAuthor = event.author;
		   }
			
		  }
		});
    },

    // 审核中查看
    updadeReason(rowRemark) {
      this.updateRemark = rowRemark.remark;
      this.updateReasonDialog = true;
    },

    // 退稿原因
    reason(content) {
      this.rejectionRemark = content.remark;
      this.centerDialogVisible = true;
    },

    baoming() {
      // this.$store.commit("SET_HEADERSWITCH", 2);
      // this.$router.push({
      //   path: "/registration",
      // });
    },

    // 退出
    logout() {
      this.$confirm("确认退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //确认退出后 删除浏览器cookie,删除token状态,返回至登录页.
          this.$http({
            url: "/api/loginOut",
            method: "get",
            params: this.$http.adornParams({}),
          })
            .then((response) => {
              let { code, data } = response.data;
              if (code === "1") {
                this.$cookie.delete("magazineToken");
                this.$store.commit("SET_TOKEN", "");
                this.$router.replace("/magaZineLogin");
                sessionStorage.removeItem("webTableSwitch");
              } else {
                this.$cookie.delete("magazineToken");
                this.$store.commit("SET_TOKEN", "");
                this.$router.replace("/magaZineLogin");
                sessionStorage.removeItem("webTableSwitch");
              }
            })
            .catch((err) => console.log(err));
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss">
[v-cloak] {
  display: none;
}
.webHome {
  width: 1200px;
  .el-tabs__nav-scroll {
    height: 40px;
    line-height: 40px;
  }

  #rejection .posiInput .el-textarea__inner {
    height: 150px !important;
    color: #333333;
    border-color: #e5e5e5;
    border: none;
  }

  #rejection .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
    padding: 10px 20px;
  }
  #rejection .el-dialog__footer {
    border-top: 2px solid #e5e5e5;
    .el-button {
      width: 118px;
      height: 34px;
      border: 1px solid #2878ff;
      line-height: 0;
      color: #2878ff;
    }
    .el-button:hover {
      background-color: #ffffff;
    }
  }

  #rejection .el-dialog .el-dialog__body {
    min-height: 140px;
    padding: 18px 32px 15px !important;
  }

  #rejection .posiReason {
    display: inline-block;
    margin: 10px 0 0 12px;
  }
  #rejection .rejectionContent {
    min-height: 140px;
    text-indent: 12px;
  }

  .el-table__body-wrapper {
    .el-button {
      line-height: 0;
    }
  }
  
  .el-table .cell {
    word-wrap: break-word;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  
  #spot_b,
  #spot_o {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    margin-top: -2px;
    left: 31%;
  }
  #spot_b {
    background-color: #2878ff;
  }
  #spot_o {
    background-color: #ff5000;
  }
}
</style>
<style scoped lang="scss">
.textP {
  color: #278dfe;
  cursor: pointer;
}
.btns button {
  line-height: 2;
  height: 34px;
  background-color: #278dfe;
  border: none;
  color: #ffffff;
  cursor: pointer;
  outline: none;
  border-radius: 2px;
  img {
    width: 20px;
    height: 20px;
    margin: 3px 2px 0 0;
  }
}
.btns1Button {
  width: 162px;
}

.btns2Button {
  width: 132px;
  margin-left: 20px;
}

.btns3Button {
  width: 105px;
  float: right;
  img {
    width: 18px !important;
    height: 18px !important;
    margin: 4px 2px 0 0 !important;
  }
}

.tablesDiv {
  width: 1200px;
  min-height: 316px;
  border: 1px solid #e5e5e5;
  margin: 26px 0 63px 0;
  .el-button {
    font-size: 12px;
  }
  ul {
    width: 1175px;
    height: 50px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-left: 10px;
    border-bottom: 1px solid #e5e5e5;
    li {
      height: 50px;
      line-height: 50px;
      padding: 0 8px;
      cursor: pointer;
      position: relative;
      .newStatus {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #e20011;
        position: absolute;
        top: 10px;
        right: 0;
      }
    }
  }
}

.is-active {
  border-bottom: 3px solid #e20011;
}

.uploadSample {
  border: none !important;
  width: 182px;
  height: 34px;
  background-color: #278dfe;
  border-radius: 3px;
  color: #ffffff !important;
  margin: 20px 0 10px 0;
  &:hover {
    background-color: #278dfe !important;
  }
}

.fileUl li {
  height: 30px;
  line-height: 30px;
  background-color: #f0f0f0;
  color: #1879c0;
  text-indent: 16px;
  margin-top: 5px;
  span {
    float: right;
    margin-right: 10px;
    cursor: pointer;
    color: #278dfe;
  }
}
.sampleFile {
  border: none !important;
  width: 132px !important;
  height: 34px !important;
  background-color: #278dfe;
  border-radius: 3px;
  color: #ffffff !important;
  &:hover {
    background-color: #278dfe !important;
  }
}
.dialogContent {
  p {
    color: #333333;
    font-weight: bold;
  }
}
.mentionP {
  font-size: 14px;
  color: #333333;
  margin: 25px 0;
}
</style>